import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { CSSProperties, ReactNode } from 'react'

import ActionContainer from 'components/containers/actionContainer'

interface Props {
  title: string
  children: ReactNode
  actions?: ReactNode
}
export default function SectionComponent(props: Props) {
  return (
    <Box style={containerStyle}>
      <Box style={sectionHeaderStyle}>
        <Typography style={sectionTitleStyle}>{props.title}</Typography>
        <ActionContainer>{props.actions}</ActionContainer>
      </Box>
      {props.children}
    </Box>
  )
}

const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
}

const sectionTitleStyle: CSSProperties = {
  display: 'inline-block',
  fontSize: '16px',
  fontWeight: 'bold',
  marginBottom: '8px',
  width: '140px',
}

const sectionHeaderStyle: CSSProperties = {
  marginBottom: '8px',
}
